import {useEffect, useState} from "react";
import useProfileAndProposals from "../hooks/useProfileAndProposals";
import {AssetsSummary, AssetTotals} from "../Assets/models/Assets";
import {assetsApiClient} from "../Assets/AssetsApiClient";
import {useHistory} from "react-router-dom";
import {MemberGroup} from "../ClientManagement/models/InvestorGroupType";
import {clientManagementApiClient} from "../ClientManagement/ClientManagementApiClient";

export const useAssetTitling = (id: string) => {
    const {profile: approvedProfile} = useProfileAndProposals(id);
    const [assets, setAssets] = useState<AssetsSummary>();
    const [assetsTotal, setAssetsTotal] = useState<AssetTotals>();
    const [isLoading, setIsLoading] = useState(false);
    const [openDrawer, updateOpenDrawer] = useState(false);
    const history = useHistory();
    const [memberGroup, setMemberGroup] = useState<MemberGroup>();
    const [openHoldings, updateOpenHoldings] = useState(false);
    const [openOptionsAndGrant, setOpenOptionsAndGrant] = useState(false);

    useEffect(() => {
        setIsLoading(true);
        Promise.all([
            assetsApiClient.getAssetsSummary(approvedProfile.id),
            assetsApiClient.getAssetTotals(approvedProfile.id),
            clientManagementApiClient.getMemberGroup(approvedProfile.id)
        ]).then(([assetSummaryResponse, assetsTotalsResponse, memberGroupResponse]) => {
            setAssets(assetSummaryResponse);
            setAssetsTotal(assetsTotalsResponse);
            setMemberGroup(memberGroupResponse);
        }).finally(() => setIsLoading(false));
    }, [approvedProfile, openDrawer]);

    useEffect(() => {
        const pathArray = history.location.pathname.split("/");
        const isHoldingsPage = pathArray.includes("Holdings")
            || pathArray.includes("LegalAgreementHoldings")
            || pathArray.includes("PartiallyOwnedInvestmentAccountHoldings")
            || pathArray.includes("HeldAwayAccountHoldings");
        updateOpenHoldings(isHoldingsPage);
        if (!isHoldingsPage) {
            const onDifferentPage = !history.location.pathname.endsWith("AssetTitling");
            updateOpenDrawer(onDifferentPage);
        }
        setOpenOptionsAndGrant(pathArray.includes("AddOptionsAndGrants"));
    }, [history.location.pathname]);

    return {
        assets,
        assetsTotal,
        isLoading,
        approvedProfile,
        openDrawer,
        memberGroup,
        openHoldings,
        openOptionsAndGrant,
    }
}